module.exports = __webpack_public_path__ + "fonts/font_3291488_ssc0i5si4es.4dc11aa9.ttf";